import { TimeRange } from "../search/timerange";

export const timeRangeLabel = {
  [TimeRange.Month]: "transactionFilter.timeRange.month",
  [TimeRange.Week]: "transactionFilter.timeRange.week",
  [TimeRange.Quarter]: "transactionFilter.timeRange.quarter",
  [TimeRange.Other]: "undefined",
};
